// extracted by mini-css-extract-plugin
export var buttonIcon = "button-icon-module--button-icon--fWhYb";
export var buttonLink = "button-icon-module--button-link--TNptz";
export var buttonNew = "button-icon-module--button-new--9hqt4";